// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2ypWN","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3iRMY","obliqueLine":"membershipbadge_obliqueLine__1Hpfc"};